export enum DROPDOWN_VARIANT {
  CONNECT_TO_DATASOURCE = "Connect to datasource",
  CREATE_OR_EDIT_RECORDS = "Create or edit records",
}
